import { render, staticRenderFns } from "./LenderDock.vue?vue&type=template&id=be05ed60"
import script from "./LenderDock.vue?vue&type=script&lang=js"
export * from "./LenderDock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports